import React from 'react';
import moment from 'moment';
import {browserHistory} from 'react-router';
import urlWithParams from 'utils/urlWithParams';
import padStart from 'lodash/padStart';
import classnames from 'classnames';
import Tooltip from 'components/pure/utils/Tooltip';

export default class ConversationTimelineIndicator extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showTooltip: false,
    };

    this.setToolTip = this.setToolTip.bind(this);
    this.callClicked = this.callClicked.bind(this);
  }

  setToolTip(toolTipState) {
    this.setState({
      showTooltip: toolTipState,
    });
  }

  callClicked(call) {
    browserHistory.push(
      urlWithParams('/calls/my', {
        fileId: call.id,
      })
    );
  }

  /**
   * pretty format numbers with leading 0's
   * @param number
   * @returns {string}
   */
  leftPad(number) {
    return padStart(number, 2, '0');
  }

  renderDuration(duration) {
    const hours = this.leftPad(duration.hours());
    const minutes = this.leftPad(duration.minutes());
    const seconds = this.leftPad(duration.seconds());
    if (duration.hours() > 0) {
      return (
        <span>
          {hours}:{minutes}:{seconds} hours
        </span>
      );
    } else {
      return (
        <span>
          {minutes}:{seconds} minutes
        </span>
      );
    }
  }

  // TODO: a must be replaced with button and eslint ignore must be removed
  /* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */
  render() {
    const {call, left, width, leftOverlay, widthOverlay, color} = this.props;
    const colorDisplay = color ? color.colorIndex : 'default';
    const duration = moment.duration(call.durationSeconds, 'seconds');
    return (
      <div className="call-indicator-wrapper color-container">
        <div
          className={classnames('call-indicator', 'color' + colorDisplay)}
          style={{left, width}}></div>
        <div
          key={call.id}
          className="call-indicator-overlay"
          style={{left: leftOverlay, width: widthOverlay}}
          data-tip
          data-for={call.id}
          onMouseEnter={() => this.setToolTip(true)}
          onMouseLeave={() => this.setToolTip(false)}
          onClick={() => this.callClicked(call)}
          ref={c => (this.callBar = c)}></div>
        <Tooltip
          id={call.id}
          renderToLayer={false}
          useLayerForClickAway={true}
          offset={{top: -10, left: 0}}
          effect="solid"
          place="top"
          type="light"
          active={this.state.showTooltip}
          parent={this.callBar}
          delayHide={200}
          onMouseEnterTooltip={() => this.setToolTip(true)}
          onMouseLeaveTooltip={() => this.setToolTip(false)}>
          <div className="call-info">
            <div>{call.description}</div>
            <div>
              {call.timestamp.format('h:mm A')} {this.renderDuration(duration)}{' '}
            </div>
            <div>
              <a href="" onClick={() => this.callClicked(call)} className="view-call">
                View Call
              </a>
            </div>
          </div>
        </Tooltip>
      </div>
    );
  }
}
